function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isCountingAggregateOp } from '../../../aggregate';
import { isScaleChannel } from '../../../channel';
import { fieldValidPredicate } from '../../../predicate';
import { signalOrValueRef } from '../../common';
import { getScaleInvalidDataMode, shouldBreakPath } from '../../invalid/ScaleInvalidDataMode';
/**
 * Create Vega's "defined" encoding to break paths in a path mark for invalid values.
 */
export function defined(model) {
  var config = model.config,
    markDef = model.markDef;
  // For each channel (x/y), add fields to break path to a set first.
  var fieldsToBreakPath = new Set();
  model.forEachFieldDef(function (fieldDef, channel) {
    var scaleType;
    if (!isScaleChannel(channel) || !(scaleType = model.getScaleType(channel))) {
      // Skip if the channel is not a scale channel or does not have a scale
      return;
    }
    var isCountAggregate = isCountingAggregateOp(fieldDef.aggregate);
    var invalidDataMode = getScaleInvalidDataMode({
      scaleChannel: channel,
      markDef: markDef,
      config: config,
      scaleType: scaleType,
      isCountAggregate: isCountAggregate
    });
    if (shouldBreakPath(invalidDataMode)) {
      var _model$stack;
      var field = model.vgField(channel, {
        expr: 'datum',
        binSuffix: (_model$stack = model.stack) !== null && _model$stack !== void 0 && _model$stack.impute ? 'mid' : undefined
      });
      if (field) {
        fieldsToBreakPath.add(field);
      }
    }
  });
  // If the set is not empty, return a defined signal.
  if (fieldsToBreakPath.size > 0) {
    var signal = _toConsumableArray(fieldsToBreakPath).map(function (field) {
      return fieldValidPredicate(field, true);
    }).join(' && ');
    return {
      defined: {
        signal: signal
      }
    };
  }
  return undefined;
}
export function valueIfDefined(prop, value) {
  if (value !== undefined) {
    return _defineProperty({}, prop, signalOrValueRef(value));
  }
  return undefined;
}